import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class ChangeOldPasswordVm {
	userName?: string;
	newPassword?: string;
	newPasswordConfirmation?: string;
	oldPassword?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userName': new UntypedFormControl(null, [...(validators['userName'] ?? []), ...[Validators.required]]),
			'newPassword': new UntypedFormControl(null, [...(validators['newPassword'] ?? []), ...[Validators.required, Validators.minLength(10), Validators.maxLength(250)]]),
			'newPasswordConfirmation': new UntypedFormControl(null, [...(validators['newPasswordConfirmation'] ?? []), ...[Validators.required, Validators.minLength(10), Validators.maxLength(250)]]),
			'oldPassword': new UntypedFormControl(null, [...(validators['oldPassword'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): ChangeOldPasswordVmFromFg {
		return new ChangeOldPasswordVmFromFg(fg);
	}
}

export class ChangeOldPasswordVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userName(): string {
		return this.fg.get('userName').value;
	}
	set userName(val) {
		this.fg.get('userName').setValue(val);
	}

	get newPassword(): string {
		return this.fg.get('newPassword').value;
	}
	set newPassword(val) {
		this.fg.get('newPassword').setValue(val);
	}

	get newPasswordConfirmation(): string {
		return this.fg.get('newPasswordConfirmation').value;
	}
	set newPasswordConfirmation(val) {
		this.fg.get('newPasswordConfirmation').setValue(val);
	}

	get oldPassword(): string {
		return this.fg.get('oldPassword').value;
	}
	set oldPassword(val) {
		this.fg.get('oldPassword').setValue(val);
	}
}
